export const CWITNESSCARD_MOBILE_STICKY_TOP = 'clamp(48px, 8vh, 72px)';
export const CWITNESSCARD_EASE_CURVE: [number, number, number, number] = [
  0.4,
  0,
  0.2,
  1,
];

export type WitnessCardMotionTriplet = [number, number, number];

export interface WitnessCardMotionProfile {
  progressStops: WitnessCardMotionTriplet;
  opacity: WitnessCardMotionTriplet;
  scale: WitnessCardMotionTriplet;
  brightness: WitnessCardMotionTriplet;
}

export const DEFAULT_WITNESS_CARD_MOTION_PROFILE: WitnessCardMotionProfile = {
  progressStops: [0, 0.5, 1],
  opacity: [0.4, 1, 1],
  scale: [0.7, 1, 1],
  brightness: [0.5, 1, 1],
};
